<template>
  <div class="insight-top-items">
    <div v-for="(item, index) in items" :key="index" class="top-item mb-3">
      <div class="d-flex align-items-center">
        <div class="rank-badge mr-3">
          <span class="badge badge-primary">{{ index + 1 }}</span>
        </div>
        <div class="flex-grow-1">
          <h6 class="mb-1">{{ item.label || item.name || item.id }}</h6>
          <div class="d-flex align-items-center">
            <div class="progress flex-grow-1 mr-2" style="height: 8px;">
              <div
                class="progress-bar"
                :style="{ width: getPercentage(item.value) + '%' }"
                role="progressbar"
              />
            </div>
            <span class="value-text">{{ formatValue(item.value) }}</span>
          </div>
          <small v-if="item.description" class="text-muted">{{ item.description }}</small>
        </div>
      </div>
    </div>
    <div v-if="items.length === 0" class="text-center text-muted py-4">
      No items available
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightTopItems',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        items: [],
      }),
    },
  },
  computed: {
    items() {
      return this.data.items || [];
    },
    maxValue() {
      if (this.items.length === 0) return 1;
      return Math.max(...this.items.map(item => item.value || 0));
    },
  },
  methods: {
    getPercentage(value) {
      if (this.maxValue === 0) return 0;
      return (value / this.maxValue) * 100;
    },
    formatValue(value) {
      if (value === null || value === undefined) return '-';
      if (typeof value === 'number') {
        return value.toLocaleString();
      }
      return value;
    },
  },
};
</script>

<style scoped>
.insight-top-items {
  padding: 0.5rem 0;
}

.top-item {
  padding: 0.75rem;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.rank-badge {
  min-width: 40px;
  text-align: center;
}

.value-text {
  min-width: 80px;
  text-align: right;
  font-weight: 600;
  color: #495057;
}
</style>

